// extracted by mini-css-extract-plugin
module.exports = {"descriptions":"descriptions--OtEtT","itemSingleline":"itemSingleline--1CfRv","itemMultiline":"itemMultiline--n6sI7"};